import { render, staticRenderFns } from "./ThemeDialog.vue?vue&type=template&id=a8511dbe&scoped=true&"
import script from "./ThemeDialog.vue?vue&type=script&lang=js&"
export * from "./ThemeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ThemeDialog.vue?vue&type=style&index=0&id=a8511dbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8511dbe",
  null
  
)

export default component.exports